import { Injectable } from '@angular/core';
import { HttpServices } from 'src/app/shared/services/http-service.service';



@Injectable({ providedIn: 'root' })
export class MembershipService {
    constructor(private http: HttpServices) { }

    GetAspUser(userId: string) {
        return this.http.get('Account/GetAspUser?userId='+userId);
    }
    DuplicateUser(UserName: string) {
        return this.http.get('Account/DuplicateUser?UserName='+UserName);
    }

    DuplicateUserWithSupplier(UserName: string) {
        return this.http.get('Account/DuplicateUserWithSupplier?UserName='+UserName);
    }

}